import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import {
    getPAJAC020CodeList,
    getPAJAC020TaskManager,
    getPAJAC050DetailsRC,
    getPAJAC050DetailsRD,
    getPAJAC050DetailsRH,
} from '../../../services/Api';
import RecruitPage from '../../../shared/components/RecruitPage';
import { BIZ_TYPE_OPTIONS } from '../../../shared/constants/app';
import { decodeToken, formatDate, getCodeName } from '../../../utils';
const PAJAC050 = () => {
    const { id } = useParams();
    const printRef = useRef();
    const [companyType, setCompanyType] = useState('');
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [data, setData] = useState({});
    const [location, setLocation] = useState({});
    const [recruitTime, setRecruitTime] = useState('');
    const [searchParams] = useSearchParams();
    const flag = searchParams.get('flag');

    const codeLists = {
        A11: [],
        A12: [],
        A14: [],
        A46: [],
    };
    const fetchData = async () => {
        try {
            getPAJAC020TaskManager()
                .then(({ data }) => {
                    codeLists.A11 = data;
                })
                .catch((error) => console.log(error));
            getPAJAC020CodeList('A11,A14,A12,A46')
                .then(({ data }) => {
                    codeLists.A11 = data.A11;
                    codeLists.A12 = data.A12;
                    codeLists.A14 = data.A14;
                    codeLists.A46 = data.A46;
                })
                .catch((error) => console.log(error));
            let response;
            if (flag === 'K') {
                response = await getPAJAC050DetailsRD(id);
            } else if (['O', 'P', 'V', 'W'].includes(flag)) {
                response = await getPAJAC050DetailsRC(id);
            } else if (['C', 'D', 'E'].includes(flag)) {
                response = await getPAJAC050DetailsRH(id);
            } else {
                throw new Error('Invalid flag value');
            }

            const data = response.data;
            setData({
                ...data,
                recruitClass: getCodeName(data.recruitClass, 'A11', codeLists),
                recruitForm: getCodeName(data.recruitForm, 'A12', codeLists),
                recruitLicense: getCodeName(data.recruitLicense, 'A14', codeLists),
                needPaper: getCodeName(data.needPaper, 'A46', codeLists),
            });
            setLocation({
                pointX: data.pointX,
                pointY: data.pointY,
            });
            setRecruitTime(data.recruitTime);
            if (data.companyType !== null) {
                const bizType = BIZ_TYPE_OPTIONS.find((item) => item.code === data.companyType);
                setCompanyType(bizType?.codeName);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [id]);

    return (
        <div className="jobPop__container" style={{ padding: '0 15px' }}>
            <div id="content">
                <div className="container">
                    <div id="job-detail" ref={printRef}>
                        {/* Top Detail */}
                        <div id="summary-job">
                            <div className="nav-job">
                                <h1>채용정보</h1>
                                <div className="jobPop__date">
                                    <p>최초 작성일 : {formatDate(data?.addDate)}</p>
                                    <p>업데이트 : {formatDate(data?.modDate)}</p>
                                </div>
                            </div>

                            <RecruitPage
                                data={data}
                                fetchData={fetchData}
                                decode={decode}
                                id={id}
                                printRef={printRef}
                                companyType={companyType}
                                recruitTime={recruitTime}
                                location={location}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PAJAC050;
